export default class Storage {
  static cookieValue(key) {
    const cookies = Object.fromEntries(document.cookie.split("; ").map((cookie) => {
      const [cookieKey, cookieValue] = cookie.split("=");

      return [cookieKey, cookieValue];
    }));

    return cookies[key];
  }

  static storageValue(key, value, useSessionStorage = false) {
    const storage = useSessionStorage ? window.sessionStorage : window.localStorage;

    try {
      if (value === null) {
        storage.removeItem(key);

        return null;
      }
      if (value !== undefined) {
        storage.setItem(key, value);

        return value;
      }

      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  static storageJsonValue(key, value) {
    if (value === null) {
      Storage.storageValue(key, value);

      return null;
    }
    if (value !== undefined) {
      Storage.storageValue(key, JSON.stringify(value));

      return value;
    }
    try {
      return JSON.parse(Storage.storageValue(key));
    } catch (error) {
      return null;
    }
  }
}
